module.exports = __webpack_public_path__ + "img/db-dark.86089bc3.svg";